/* This file will have the bread crumb details pertaining to each page of the application */
declare var ENV_PORTAL: any;
const browseCrumb = ( ENV_PORTAL === 'fnabc' ) ? 'FirstNet Apps & Solutions' : 'Marketplace';

export const BREADCRUMBS = {
  'staticbrowse': [{ label: 'Home', routerLink: '/home' }],
  'staticAppMarketPlace': [{ label: 'Home', routerLink: '/home' }, { label: browseCrumb, routerLink: '/browse' }],
  'staticDeviceManagementProgram': [{ label: 'Home', routerLink: '/home' }],
  'staticmanage': [{ label: 'Home', routerLink: '/home' }],
  'staticdashboard': [{ label: 'Home', routerLink: '/home' }],
  'staticmanagedashboard': [{ label: 'Home', routerLink: '/home' }, { label: 'Dashboard', routerLink: '/dashboard' }],
  'staticmanageshop': [{ label: 'Home', routerLink: '/home' }, { label: browseCrumb, routerLink: '/browse' }],
  'staticadduser': [{ label: 'Home', routerLink: '/home' }, { label: 'Console dashboard', routerLink: '/dashboard' }],
  'staticBreadCrumbAvailable': ['browse', 'AppMarketPlace', 'DeviceManagementProgram', 'manage', 'dashboard', 'managedashboard', 'manageshop', 'adduser', 'learn', 'support', 'contact', 'manageInventory', 'efota'],
  'staticlearn': [{ label: 'Home', routerLink: '/home' }],
  'staticwelcome': [{ label: 'Home', routerLink: '/home' }],
  'staticmanageInventory': [{ label: 'Home', routerLink: '/home' }, { label: 'Manage accounts', routerLink: '/manageInventory' }],
  'staticsupport': [{ label: 'Home', routerLink: '/home' }],
  'staticcontact': [{ label: 'Home', routerLink: '/home' }],
  'staticefota': [{ label: 'Home', routerLink: '/home' }, { label: 'Dashboard', routerLink: '/dashboard' }]
};
